import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { setUserInfo } from '../store/slices/userInfoSlice';
import { pushLogin } from '../store/slices/loginsSlice';
import { setApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

import { createStdRequest, apiFetch } from '../utils/utils';

import ReduxLoader from '../store/ReduxLoader';

class DevMode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: undefined,
      loggedIn: false,
      haveError: false,
      errorMessage: '',
    };
  }

  componentDidMount() {
    const uri = '/api/account/loginAsDev';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      const { success, userId, personId, email, phone, role, prefName, lastName, firmId, firmName, errorDescrip } =
        json;
      if (success) {
        const loginObj = { loginType: 'asDev' };
        this.props.pushLogin(loginObj);
        const userInfo = { userId, personId, email, phone, role, prefName, lastName };
        const firmInfo = { firmId, firmName };
        this.props.setUserInfo(userInfo);
        ReduxLoader.setFirmInfoAndNotifyWebSocket(firmInfo);
        ReduxLoader.quasiLoadStateForNoFirm();
        this.setState({ loggedIn: true });
      } else {
        this.setState({ haveError: true, errorMessage: errorDescrip });
      }
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    } else if (this.state.loggedIn) {
      return <Redirect to="/homeDispatcher" />;
    } else if (this.state.haveError) {
      return (
        <div>
          <h3>Encountered Error</h3>
          <div style={{ marginLeft: '20px', color: 'red' }}>{this.state.errorMessage}</div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default connect(null, { setUserInfo, pushLogin, setApiResponseInfo })(DevMode);
